import React from 'react';
import { injectIntl } from 'react-intl';
import { Form, Input, Icon } from 'antd';
import styles from './InfoGatheringQuestionItem.module.scss';
import placeholder from '../../Placeholders/PlaceholdersMessages';
import BotQuestionTypeSelect from '../ScreeningQuestionItem/BotQuestionTypeSelect';

function InfoGatheringQuestionItem(props) {
  const {
    categoryErrors,
    removeQuestion,
    question,
    questionErrors,
    readOnly,
    intl,
    onQuestionFieldChange,
    getHelpMessageForQuestion,
    isDragAllowed,
    onCategoryChange,
    setInputBoxSelected,
  } = props;

  const isCategoryDisabled =
    readOnly ||
    question.ExpectedAnswer.toLowerCase() === 'phonenumber' ||
    question.ExpectedAnswer.toLowerCase() === 'appointment' ||
    question.ExpectedAnswer.toLowerCase() === 'registration' ||
    question.ExpectedAnswer.toLowerCase() === 'interviewlocation';

  const disableCloseText = !question.Order.includes('.');
  return (
    <div
      className={styles.infoGatheringQuestionItem}
      data-testid="info-gathering-question-item"
      style={{ cursor: isDragAllowed ? 'move' : 'default' }}
    >
      <div className={styles.questionNumber}>{question.Order}</div>
      <div className={styles.infoGatheringQuestionItemWrapper}>
        <div
          className={styles.infoGatheringCategoryWrapper}
          style={{ position: 'relative' }}
          id={`question-order-${question.Order}`}
        >
          <Form.Item
            validateStatus={categoryErrors && categoryErrors[question.Order] ? 'error' : ''}
            help={categoryErrors && categoryErrors[question.Order] ? 'Category name is required' : ''}
          >
            <Input
              className={`${styles.infoGatheringCategory} ${isCategoryDisabled ? styles.disabled : ''}`}
              value={question.CategoryName}
              placeholder={intl.formatMessage({ ...placeholder.addCategoryNameLabel })}
              onChange={event => onQuestionFieldChange('CategoryName', question.Order, event.target.value)}
              disabled={isCategoryDisabled}
              onFocus={() => setInputBoxSelected(true)}
              onBlur={() => setInputBoxSelected(false)}
            />
          </Form.Item>
          {!question.Id ? (
            <BotQuestionTypeSelect
              value={question.ExpectedAnswer}
              readOnly={readOnly}
              onSelect={val => onCategoryChange(question.Order, val)}
              parentId={`question-order-${question.Order}`}
              disableCloseText={disableCloseText}
            />
          ) : null}
          {!readOnly ? (
            <Icon
              type="minus-circle"
              onClick={() => removeQuestion(question.Order)}
              data-testid="remove-icon"
              style={{ fontSize: 18 }}
            />
          ) : null}
        </div>
        <div className={styles.infoGatheringQuestion}>
          <Form.Item
            validateStatus={questionErrors && questionErrors[question.Order] ? 'error' : ''}
            help={getHelpMessageForQuestion(questionErrors, question)}
          >
            <Input
              className={styles.questionInput}
              value={question.Question}
              placeholder={intl.formatMessage({ ...placeholder.addAQuestionLabel })}
              onChange={event => onQuestionFieldChange('Question', question.Order, event.target.value)}
              maxLength={255}
              disabled={readOnly}
              onFocus={() => setInputBoxSelected(true)}
              onBlur={() => setInputBoxSelected(false)}
            />
          </Form.Item>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(InfoGatheringQuestionItem);
export { InfoGatheringQuestionItem as InfoGatheringQuestionItemWithoutInjectIntl };
